import { render, staticRenderFns } from "./ChatMessages.vue?vue&type=template&id=cd169bda&scoped=true"
import script from "./ChatMessages.vue?vue&type=script&lang=js"
export * from "./ChatMessages.vue?vue&type=script&lang=js"
import style0 from "./ChatMessages.vue?vue&type=style&index=0&id=cd169bda&prod&lang=css"
import style1 from "./ChatMessages.vue?vue&type=style&index=1&id=cd169bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../worksheets/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd169bda",
  null
  
)

export default component.exports